import React, { useEffect } from 'react'
import useCustomerProfile from './useCustomerProfile'
import { formatDate } from '../../utils/dateUtils';

const VipCustomerList = () => {

  const {profiles, getVipProfile} = useCustomerProfile()


  const isToday = (date) => {
    const today = new Date();
    const givenDate = new Date(date);
    return (
      today.getDate() === givenDate.getDate() &&
      today.getMonth() === givenDate.getMonth() &&
      today.getFullYear() === givenDate.getFullYear()
    );
  };

  useEffect(() => {
    getVipProfile()
  },[])
  
  return (
    <div>
      <h2 className='text-5xl'>รายชื่อลูกค้า VIP</h2>
      <table className="min-w-full divide-y divide-gray-300">
        <thead className="bg-gray-50">
          <tr>
            <th scope="col" className="py-3.5 pl-4 pr-3 text-left text-lg font-semibold text-gray-900 sm:pl-6">
              No
            </th>
            <th scope="col" className="px-3 py-3.5 text-left text-lg font-semibold text-gray-900">
              Contact
            </th>
            <th scope="col" className="px-3 py-3.5 text-left text-lg font-semibold text-gray-900">
              วันที่เป็น Vip
            </th>
            <th scope="col" className="px-3 py-3.5 text-left text-lg font-semibold text-gray-900">
              Type
            </th>
          </tr>
        </thead>
        <tbody>
          {profiles && profiles.map((profile, index) => {
              const contact = profile.CustomerProfile.contact
              const vipDate = profile.vipDate
              const type = profile.type
              const isVipToday = isToday(vipDate);
              return <tr key={contact} className={isVipToday ? 'bg-yellow-200' : ''}>
                <td className="whitespace-nowrap py-4 pl-4 pr-3 text-lg font-medium text-gray-900 sm:pl-6">
                  {index + 1}
                </td>
                <td className="whitespace-nowrap px-3 py-4 text-lg text-gray-500">{contact}</td>
                <td className="whitespace-nowrap px-3 py-4 text-lg text-gray-500">{formatDate(vipDate)}</td>
                <td className="whitespace-nowrap px-3 py-4 text-lg text-gray-500">{type}</td>
              </tr>
            })}
        </tbody>
      </table>
    </div>
  )
}

export default VipCustomerList